import moment from "moment";
import { useEffect, useLayoutEffect, useState } from "react";
import { appConfig } from "../../configs";
import { IDatePickerProps } from "../DateRangePicker/DateRangePicker";

import { View } from "./View";

export interface IDatePopOverProps extends IDatePickerProps {
  setStartDate: (date: string | number | Date) => void;
  setEndDate: (date: string | number | Date) => void;
  setQueryString?: boolean;
}

export interface IDatePopOverViewProps extends IDatePopOverProps {
  isOpen: boolean;
  dateString: string;
  togglePopover: () => void;
  className?: string;
}

export const DatePopOver = (props: IDatePopOverProps) => {
  const { startDate, endDate, setStartDate, setEndDate } = props;

  const [isOpen, setOpen] = useState(false);

  const [dateString, changeDateString] = useState(
    `${appConfig.dateFormat1}-${appConfig.dateFormat1}`
  );

  // const setStartDate = (dtString: string) => {
  //   changeStartDate(formatDate(dtString));
  // };
  // const setEndDate = (dtString: string) => {
  //   changeEndDate(formatDate(dtString));
  // };

  const setDisplayDateFormat = () => {
    changeDateString(
      moment(startDate).format(appConfig.dateFormat1) +
        " - " +
        moment(endDate).format(appConfig.dateFormat1)
    );
  };

  useEffect(() => {
    setDisplayDateFormat();
    // startDate !== null && setOpen(!isOpen); // close calendar if start already selected
  }, [startDate]);

  useEffect(() => {
    setDisplayDateFormat();
    setOpen(!isOpen);
  }, [endDate]);

  useLayoutEffect(() => {
    setTimeout(() => setOpen(false), 20); // close on load. It pops open due to changing endDate from Query
  }, []);

  const formatDate = (dateString: string | number | Date) => {
    const options = {
      dateStyle: "medium",
    };

    // console.log("dateString: ", dateString);

    // return moment(dateString).valueOf(); //.format(appConfig.javascriptCodeDateFormat);
    return new Date(dateString).toLocaleDateString(/*[], options*/);
  };

  const togglePopover = () => {
    setOpen(!isOpen);
  };

  return (
    <View
      {...props}
      setStartDate={(dtString) => setStartDate(formatDate(dtString))}
      setEndDate={(dtString) => setEndDate(formatDate(dtString))}
      isOpen={isOpen}
      togglePopover={togglePopover}
      dateString={dateString}
    />
  );
};
